import { UntypedFormGroup, ValidatorFn, UntypedFormArray, ValidationErrors } from '@angular/forms';

export const checkboxesCheckedError = 'required';

export function checkboxesCheckedValidator(minRequired = 1): ValidatorFn {
  return function validate(formGroup: UntypedFormGroup | UntypedFormArray): ValidationErrors | null {
    const totalChecked = Object.keys(formGroup.controls)
      .map((key) => formGroup.controls[key].value)
      .reduce((total, value) => (value ? ++total : total), 0);

    return totalChecked < minRequired ? { [checkboxesCheckedError]: true } : null;
  };
}
